import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { User } from './types/User';

const impersonateUser = (makeCall: MakeCall) => (userId: number) =>
  makeCall<User>('PUT', `/api/v2/user/${userId}/impersonate`);

export { impersonateUser };
